import React from "react";
const icons = import.meta.glob("/src/assets/icons/*.svg", { eager: true });

function PoetIcon({ iconName, color, style }) {
  const iconPath = icons[`/src/assets/icons/${iconName}.svg`]?.default;

  return (
    <div
      data-testid="poet-icon"
      style={{
        display: "inline-block",
        width: "1.5em",
        height: "1.5em",
        color: color || "#7745FF",
        mask: `url("${iconPath}") no-repeat center`,
        WebkitMask: `url("${iconPath}") no-repeat center`,
        backgroundColor: "currentColor",
        verticalAlign: "middle",
        ...style,
      }}
    ></div>
  );
}

export default PoetIcon;
